export default __webpack_public_path__ + "static/media/zoomed_horizontal_lighttodark.b6c0aee0.png";